<template>
  <section class="collector-channel-config">
    <el-table stripe :data="value">
      <el-table-column :label="$t('common.collectorChannelConfig.col1')" width="120" align="center">
        <template slot-scope="scope">
          <!-- <span>{{scope.row.no}}</span> -->
          <el-input v-model="scope.row.channelNo" :disabled="disabled||scope.row.isUsed"></el-input>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.collectorChannelConfig.col2')" align="center">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.protocol"
            :placeholder="$t('common.collectorChannelConfig.col2Placeholder')"
            :disabled="scope.row.isUsed"
            style="width:100%"
            @change="emitChange"
          >
            <el-option
              v-for="(item,index) in options"
              :key="index"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
    </el-table>
  </section>
</template>

<script>
export default {
  inject: ['form', 'extraParams'],
  model: {
    prop: 'collectorChannelConfig',
    event: 'change',
  },
  props: {
    collectorChannelConfig: {
      type: Array,
      default() {
        return [];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    channelNum() {
      return this.form.channelNum;
    },
    collectorType() {
      return this.extraParams && this.extraParams.collectorType;
    },
  },
  data() {
    return {
      value: [...this.collectorChannelConfig],
      options: [],
    };
  },
  watch: {
    collectorChannelConfig(newVal) {
      this.value = [...newVal];
    },
    channelNum() {
      this.formatValue(); // 格式化value
    },
    collectorType() {
      // 重新获取协议选项
      this.getProtocolOptions();
    },
  },
  created() {
    this.getProtocolOptions();
  },
  methods: {
    emitChange() {
      this.$emit('change', this.value);
    },
    getDefaultProtocol() {
      let { collectorType } = this.extraParams;
      // collectorType可能在Form里
      if (!collectorType) {
        collectorType = this.form.collectorType;
      }
      if (collectorType === 'HDA') {
        return 'HDA2';
      }
      return collectorType;
    },
    formatValue() {
      const value = this.value;
      const newValue = [];
      for (let i = 0; i < this.channelNum; i++) {
        // 通道号是字符串类型
        const channelNo = `${i + 1}`;
        if (value[i] && Object.keys(value[i]).length) {
          newValue.push({ ...value[i], channelNo });
        } else {
          newValue.push({ channelNo, protocol: this.getDefaultProtocol(), isUsed: false });
        }
      }
      this.value = newValue;
      this.emitChange();
    },
    getProtocolOptions() {
      this.$store
        .dispatch('device/GetCollectorProtocolOptions', {
          type: this.collectorType,
        })
        .then((options) => {
          this.options = options;
        });
    },
  },
};
</script>

<style lang="scss">
.collector-channel-config {
  .el-table {
    border: 1px solid #ebeef5;
  }
  .el-input {
    input {
      text-align: center;
    }
  }
}
</style>
